export function classNames(classNamesDefs: Record<string, boolean>) {
  return Object.entries(classNamesDefs)
    .filter(([name, enabled]) => enabled && !!name)
    .map(([name]) => name)
    .join(' ');
}
